<template>
  <a-form ref='ruleForm' :rules="rules" :model='form' :labelCol="{span:3}" :wrapper-col="{span:19}">
    <a-form-item label="选择类型" name="area_type">
      <a-radio-group v-model:value="form.area_type">
        <a-radio :value="1">按行政区域</a-radio>
        <a-radio :value="2">按GPS</a-radio>
      </a-radio-group>
      <a-tooltip placement='right'>
        <template #title>1、按经纬度指定了GPS坐标之后，系统将以坐标为中心，以输入的范围为半径来确定活动参与范围，在活动范围内的用户，扫码将发放指定的奖项；<br />
          2、按GPS坐标指定活动范围可能存在20m左右的误差
        </template>
        <InfoCircleOutlined />
      </a-tooltip>
    </a-form-item>
    <a-form-item label="GPS来源" required v-if="form.area_type==2">
      <div class="m-b-10">
        <!-- <a-button type="primary" @click="storeVisible=true" class="m-r-10">添加门店</a-button> -->
        <a-button type="primary" @click='showMap=true'>添加指定GPS</a-button>
      </div>
      <div>
        <a-table :pagination='false' bordered :columns='columns' :data-source='list' :scroll="{ x: 'max-content'}">
          <template v-slot:name="{ record }">
            <a-input v-model:value="record.name" style="width:300px;" :maxlength='10' placeholder="请输入名称" />
          </template>
          <template v-slot:range="{ record }">
            <a-input-number :precision="0" v-model:value="record.range" style="width:300px; text-align: center" placeholder="范围" />
          </template>
          <template v-slot:action="{ index }">
            <a-button type="danger" size="small" href="javascript:;" @click="del(index)">删除</a-button>
          </template>
        </a-table>
      </div>
    </a-form-item>
    <a-form-item label="行政区域" v-if="form.area_type==1">
      <a-row class="m-b-15" type="flex" justify="space-between" align="middle">
        <a-col :span="8">
          <div class="">
            <a-select v-model:value="country" placeholder="请选择">
              <a-select-option :value="100000">全国</a-select-option>
            </a-select>
            <a-select v-model:value="province" allowClear placeholder="请选择省" @change="selectProvince" id="province">
              <a-select-option v-for='(item,index) in provinceList' :key="index" :value="item.id">{{item.name}}
              </a-select-option>
            </a-select>
            <a-select v-model:value="city" allowClear placeholder="请选择市" @change="selectCity" v-if="cityList.length" id="city">
              <a-select-option v-for='(item,index) in cityList' :key="index" :value="item.id">{{item.name}}
              </a-select-option>
            </a-select>
            <a-select v-model:value="area" allowClear placeholder="请选择区" @change="selectArea" v-if="areaList.length" id="area">
              <a-select-option v-for='(item,index) in areaList' :key="index" :value="item.id">{{item.name}}
              </a-select-option>
            </a-select>
          </div>
        </a-col>
        <a-col :span="2">
          <a-button type="primary" @click="addCity">添加</a-button>
        </a-col>
        <a-col :span="8">
          <div class=" s_bor10 p-5 height-160" style="overflow-x: auto;overflow-y:scroll;border:1px solid #ccc">
            <div class="s_flex_bian_c s_bf58 bor-rad-5 p-tb0-lr10 m-b-10" v-for='(item,index) in rigthArr' :key='index'>
              <p>{{item.country_name}}{{item.province_name}}{{item.city_name}}{{item.area_name}}</p>
              <CloseCircleFilled class="s_c999" v-if='$route.query.type == "look"' />
              <CloseCircleFilled class="s_c999" @click='delRegion(index)' v-else />
            </div>
          </div>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item :wrapper-col="{offset:10}">
      <a-button @click="submit" type="primary" class="m-r-10">确定</a-button>
      <a-button @click="cancel">取消</a-button>
    </a-form-item>
  </a-form>
  <!-- 选择门店 -->
  <a-modal  :keyboard="false" v-model:visible="storeVisible" centered style="width:700px" :width='1000' :footer="null" destroyOnClose>
    <selectStore v-on:select="storeSelect" :selectList='storeList' :checkout='true'></selectStore>
  </a-modal>
  <!-- 选择经纬度 -->
  <a-modal  :keyboard="false" title="选择经纬度" centered v-model:visible="showMap" :width='1000' :footer="null" destroyOnClose>
    <!-- :lng='form.lng' :lat='form.lat' -->
    <gdmap v-on:confirm="confirm"></gdmap>
  </a-modal>
</template>

<script>
import { inject, onMounted, reactive, ref, toRefs } from "vue";
import { InfoCircleOutlined, CloseCircleFilled } from "@ant-design/icons-vue";
import { getArea } from "@/api/public";
import { message } from "ant-design-vue";
const rule = {
  area_type: { required: true, message: "请选择地区类型" },
};
const columns = [
  {
    title: "名称",
    dataIndex: "name",
    key: "name",
    slots: { customRender: "name" },
  },

  {
    title: "经纬度",
    dataIndex: "latlng",
    key: "latlng",
    customRender: ({ record }) => {
      return record.lat + "-" + record.lng;
    },
  },
  {
    title: "范围 (米)",
    dataIndex: "range",
    key: "range",
    slots: { customRender: "range" },
  },
  {
    title: "操作",
    key: "action",
    slots: { customRender: "action" },
  },
];
export default {
  components: { CloseCircleFilled },
  name:'areaComponents',
  setup(props, { emit }) {
    const ruleForm = ref();
    const form = ref({ area_type: 1, rule_mark_area: 1 });
    // 门店选择
    const storeState = reactive({
      storeVisible: false,
      storeList: [],
      list: [],
    });
    const storeSelect = (data) => {
      storeState.storeList = storeState.storeList.concat(data);
      storeState.list = storeState.list.concat(data);
      storeState.storeVisible = false;
    };
    // 删除
    const del = (index) => {
      storeState.storeList.splice(index, 1);
      storeState.list.splice(index, 1);
    };
    const mpaState = reactive({
      showMap: false,
    });
    // 经纬度选择完毕
    const confirm = (value) => {
      value.min = 0;
      value.max = 0;
      value.name = '默认'
      storeState.storeList = storeState.storeList.concat(value);
      storeState.list = storeState.list.concat(value);
      mpaState.showMap = false;
      // form.value.lat = value.lat;
      // form.value.lng = value.lng;
      // state.showMap = false;
    };
    // 行政区域
    const _lodash = inject("_lodash");
    const state = reactive({
      provinceList: [],
      province: "",
      city: "",
      cityObj: {
        province_name: "",
        city_name: "",
        area_name: "",
        id: [],
      },
      cityList: [],
      area: {},
      areaList: [],
      addressList: [],
      rigthArr: [],
    });
    //获取省市区
    const getAreaList = async (arr) => {
      let result = await getArea().then((res) => res);
      state.provinceList = result.data;
      state.addressList = result.data;
    };
    // 销售区域选择省
    const selectProvince = (e, option) => {
      if (_lodash.indexOf(state.cityObj.id, 100000) !== -1) {
        state.cityObj.id = _lodash.filter(state.cityObj.id, function (o) {
          return o != 100000;
        });
      }
      if (e && option) {
        state.cityList = state.provinceList[option.key].children;
        state.city = undefined;
        state.area = undefined;
        state.cityObj = {
          province_name: state.provinceList[option.key].name,
          city_name: "",
          area_name: "",
          id: [e],
        };
      } else {
        state.cityList = [];
        state.areaList = [];
        state.province = undefined;
        state.city = undefined;
        state.area = undefined;
        state.cityObj = {
          province_name: "",
          city_name: "",
          area_name: "",
          id: [],
        };
      }
    };
    // 销售区域选择市
    const selectCity = (e, option) => {
      if (_lodash.indexOf(state.cityObj.id, 100000) !== -1) {
        state.cityObj.id = _lodash.filter(state.cityObj.id, function (o) {
          return o != 100000;
        });
      }
      if (e && option) {
        state.cityObj.id.splice(1, 2);
        state.areaList = state.cityList[option.key].children;
        state.area = undefined;
        state.cityObj.id.push(e);
        state.cityObj = {
          ...state.cityObj,
          city_name: state.cityList[option.key].name,
          area_name: "",
        };
      } else {
        state.cityObj.id.splice(1, 2);
        state.areaList = [];
        state.city = undefined;
        state.area = undefined;
        state.cityObj = {
          ...state.cityObj,
          city_name: "",
          area_name: "",
        };
      }
    };
    // 销售区域选择区
    const selectArea = (e, option) => {
      if (_lodash.indexOf(state.cityObj.id, 100000) !== -1) {
        state.cityObj.id = _lodash.filter(state.cityObj.id, function (o) {
          return o != 100000;
        });
      }
      if (e && option) {
        state.cityObj.id.splice(2, 1);
        state.cityObj.id.push(e);
        state.cityObj = {
          ...state.cityObj,
          area_name: state.areaList[option.key].name,
        };
      } else {
        state.area = undefined;
        state.cityObj.id.splice(2, 1);
        state.cityObj = {
          ...state.cityObj,
          area_name: "",
        };
      }
    };
    // 清空
    const clearCityArr = () => {
      state.province = undefined;
      state.city = undefined;
      state.area = undefined;
      state.cityList = [];
      state.areaList = [];
      state.cityObj = {
        country_name: "",
        province_name: "",
        city_name: "",
        area_name: "",
        id: [],
      };
    };
    // 添加销售区域
    const addCity = () => {
      var left = state.cityObj; //左边数组
      var right = state.rigthArr; //右边数组
      if (_lodash.indexOf(left.id, 100000) !== -1) {
        left.id = _lodash.filter(left.id, function (o) {
          return o != 100000;
        });
      }
      if (left.id.length == 0) {
        left.id.unshift(100000);
        left.country_name = "全国";
        if (right.length == 0) {
          right.push(_lodash.cloneDeep(left));
          clearCityArr();
        } else {
          message.error("已有相同区域！");
        }
        return;
      }
      if (right.length == 0) {
        left.id.unshift(100000);
        right.push(_lodash.cloneDeep(left));
        clearCityArr();
        return false;
      } else {
        left.id.unshift(100000);
        for (var i in right) {
          if (left.country_name == "全国" || right[i].country_name == "全国") {
            message.error("已有相同区域！");
            return false;
          }
          if (
            right[i].province_name == left.province_name &&
            right[i].city_name == left.city_name &&
            right[i].area_name == left.area_name
          ) {
            message.error("已有相同区域！");
            return false;
          }
          if (
            right[i].province_name == left.province_name &&
            right[i].city_name == left.city_name
          ) {
            if (right[i].id.length !== left.id.length) {
              message.error("已有相同区域！");
              return false;
            }
          }
          if (right[i].province_name == left.province_name) {
            if (right[i].city_name == "" || left.city_name == "") {
              message.error("已有相同区域！");
              return false;
            }
          }
        }
      }
      right.push(_lodash.cloneDeep(left));
      clearCityArr();
    };
    // 删除销售区域
    const delRegion = (e) => {
      state.rigthArr.splice(e, 1);
    };
    onMounted(() => {
      getAreaList();
    });
    const submit = () => {
      ruleForm.value.validate().then(async (res) => {
        var emitData = {};
        if (form.value.area_type == 1) {
          console.log(form.value);
          console.log(state.rigthArr);
          if (!state.rigthArr.length) {
            message.error("请选择行政区域");
            return;
          }
          emit("ployDone", { ...form.value, area_region_arr: state.rigthArr });
        } else {
          if(!storeState.list.length){
            message.error('请指定GPS！')
            return false
          }
          emit("ployDone", { ...form.value, area_gps_arr: storeState.list });
        }
      });
    };
    const cancel = () => {
      emit("cancel");
    };
    const renderDetail = (data, index) => {
      form.value = data;
      form.value.index = index;
      state.rigthArr = data.area_region_arr || [];
      storeState.list = data.area_gps_arr || [];
      getAreaList();
    };
    return {
      ruleForm,
      form,
      columns,
      ...toRefs(storeState),
      storeSelect,
      del,
      confirm,
      ...toRefs(mpaState),
      ...toRefs(state),
      selectCity,
      selectArea,
      selectProvince,
      addCity,
      submit,
      cancel,
      renderDetail,
      delRegion,
    };
  },
};
</script>
